"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _group = require("@/api/group");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
var _default = exports.default = {
  props: {},
  data: function data() {
    return {
      activeName: 'detail',
      direction: 'rtl',
      dialogVisible: false,
      activityInfo: {},
      groupStatusArr: ['初始化', '已拒绝', '已撤销', '待审核', '已通过'],
      groupProcessArr: ['未开始', '进行中', '已结束']
    };
  },
  watch: {},
  mounted: function mounted() {
    this.activeName = 'detail';
  },
  methods: {
    openClose: function openClose(item) {
      if (item.visible) {
        this.$set(item, 'visible', false);
      } else {
        this.$set(item, 'visible', true);
      }
    },
    handleClose: function handleClose() {
      this.dialogVisible = false;
    },
    //强制关闭
    close: function close(id) {
      var _this = this;
      this.$modalSure('要将此活动强制关闭吗？').then(function () {
        (0, _group.groupActivityClose)(id).then(function (res) {
          _this.$message({
            type: 'success',
            message: '关闭成功!'
          });
          _this.$emit('changeList');
          _this.dialogVisible = false;
        });
      });
    },
    //审核通过
    pass: function pass(id) {
      var _this2 = this;
      this.$modalSure('要将此活动审核通过吗？').then(function () {
        (0, _group.groupActivityPass)(id).then(function (res) {
          _this2.$message({
            type: 'success',
            message: '审核成功!'
          });
          _this2.$emit('changeList');
          _this2.dialogVisible = false;
        });
      });
    },
    //审核拒绝
    refuse: function refuse(id) {
      var _this3 = this;
      this.$modalPrompt('textarea', '拒绝原因').then(function (V) {
        (0, _group.groupActivityRefuse)({
          id: id,
          reason: V
        }).then(function (res) {
          _this3.$message({
            type: 'success',
            message: '审核成功!'
          });
          _this3.$emit('changeList');
          _this3.dialogVisible = false;
        });
      });
    }
  }
};